import React from 'react';
import { CalendarCheck, Truck, Trash2 } from 'lucide-react';
const STEPS = [{
  icon: CalendarCheck,
  title: '1. Reserve online',
  body: 'Pick your size and delivery date, then reserve in minutes. Pay by card now or place a card on file.'
}, {
  icon: Truck,
  title: '2. We deliver',
  body: 'We drop off your dumpster right where you need it — most orders delivered as soon as the next day.'
}, {
  icon: Trash2,
  title: '3. We haul it away',
  body: "Fill it at your own pace during your rental window. When you're done, we pick it up and dispose of it."
}];
export function HowItWorks() {
  return <section id="how-it-works" className="w-full bg-background py-16 md:py-24" data-id="element-244">
      <div className="container" data-id="element-245">
        <div className="mx-auto max-w-2xl text-center" data-id="element-246">
          <h2 className="text-3xl font-semibold tracking-tight text-foreground sm:text-4xl" data-id="element-247">
            How it works
          </h2>
          <p className="mt-3 text-muted-foreground" data-id="element-248">
            Renting a dumpster with Greeneway takes three simple steps.
          </p>
        </div>

        <div className="mt-12 grid gap-8 md:grid-cols-3" data-id="element-249">
          {STEPS.map(step => <div key={step.title} className="text-center" data-id="element-250">
              <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10 text-primary" data-id="element-251">
                <step.icon className="h-7 w-7" data-id="element-252" />
              </span>
              <h3 className="mt-5 text-lg font-semibold text-foreground" data-id="element-253">
                {step.title}
              </h3>
              <p className="mt-2 text-sm text-muted-foreground" data-id="element-254">{step.body}</p>
            </div>)}
        </div>
      </div>
    </section>;
}